const SHAPES_HISTORY_LIMIT = 100;

class Limiter {
    constructor(axl) {
        this.axl = axl;
        this.value = SHAPES_HISTORY_LIMIT;
        this.elem = document.getElementById("limit-message");
        this.closeElem = document.getElementById("limitclosebtn");
        this.closeElem.addEventListener('click', this.hideMessage.bind(this));
    }

    hideMessage(e = null) {
        if (e && this.axl) {
            this.axl.sendMessage(AxL.ChildToHost.TRACK, {
                action: "hide_too_many_shapes_or_memory_message",
                nonInteraction: false
            });
        }
        this.elem.classList.remove('shown');
    }

    showMessage(count, memory) {
        this.elem.classList.add('shown');
        if (this.axl) {
            this.axl.sendMessage(AxL.ChildToHost.TRACK, {
                action: "too_many_shapes_or_memory",
                nonInteraction: true,
                value: 'shapes : ' + count + ', memory : ' + memory
            });
        }
    }
};

export { Limiter };